// Locally proxied by Vite
// And on Netlify proxied using github workflows & netlify.toml file
export const API_ENTRYPOINT = "/api";
